var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observable, computed, action, makeObservable } from 'mobx';
import { messageService } from '../../store/singleton';
import * as dateFns from 'date-fns';
export var MessageGroup;
(function (MessageGroup) {
    MessageGroup[MessageGroup["LastNYear"] = 0] = "LastNYear";
    MessageGroup[MessageGroup["ThisYear"] = 1] = "ThisYear";
    MessageGroup[MessageGroup["ThisMonth"] = 2] = "ThisMonth";
    MessageGroup[MessageGroup["ThisWeek"] = 3] = "ThisWeek";
    MessageGroup[MessageGroup["Yesterday"] = 4] = "Yesterday";
    MessageGroup[MessageGroup["Today"] = 5] = "Today";
})(MessageGroup || (MessageGroup = {}));
var Message = (function () {
    function Message(message) {
        Object.defineProperty(this, "messageId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "displayInitial", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dateCreated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "blobId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "filename", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isBeingSent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isDownloading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this);
        this.messageId = message.messageId;
        this.message = message.message;
        this.userId = message.userId;
        this.userName = message.userName;
        this.displayInitial = message.displayInitial;
        this.dateCreated = message.dateCreated;
        this.blobId = message.blobId;
        this.filename = message.filename;
        this.isBeingSent = message.isBeingSent || false;
        this.isDownloading = message.isDownloading || false;
    }
    Object.defineProperty(Message.prototype, "localDate", {
        get: function () {
            return new Date(this.dateCreated + "Z");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "getAttachment", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId) {
            return __awaiter(this, void 0, void 0, function () {
                var response_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.isDownloading = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            if (!(this.blobId && this.filename)) return [3, 3];
                            return [4, messageService.getAttachment(masterAccountId, this.blobId, this.filename)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [3, 5];
                        case 4:
                            response_1 = _a.sent();
                            return [3, 5];
                        case 5:
                            this.isDownloading = false;
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(Message.prototype, "getHeaderClasses", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (currentUserId) {
            if (this.isMyMessage(currentUserId)) {
                return 'message-header message-mine';
            }
            return 'message-header';
        }
    });
    Object.defineProperty(Message.prototype, "getContentClasses", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (currentUserId) {
            if (this.isBeingSent) {
                return 'message message-mine sending';
            }
            if (this.isMyMessage(currentUserId)) {
                return 'message message-mine';
            }
            return 'message';
        }
    });
    Object.defineProperty(Message.prototype, "getAttachmentClasses", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (currentUserId) {
            if (this.isMyMessage(currentUserId)) {
                return 'download pxl-c4';
            }
            return 'download pxl-c11-3 pxl-text-c11-6';
        }
    });
    Object.defineProperty(Message.prototype, "getDateClasses", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (currentUserId) {
            if (this.isMyMessage(currentUserId)) {
                return 'pxl-text-right pxl-text-xsmall pxl-text-c11-6';
            }
            return 'pxl-text-xsmall pxl-text-c11-6';
        }
    });
    Object.defineProperty(Message.prototype, "isMyMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (currentUserId) {
            return currentUserId === this.userId;
        }
    });
    Object.defineProperty(Message.prototype, "printDate", {
        get: function () {
            return dateFns.format(this.localDate, 'hh:mm a');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "printGroupDate", {
        get: function () {
            switch (this.getMessageGroup()) {
                case MessageGroup.LastNYear:
                    return dateFns.format(this.localDate, 'EEEE, MMMM d, yyyy');
                case MessageGroup.ThisYear:
                    return dateFns.format(this.localDate, 'EEEE, MMMM d');
                case MessageGroup.ThisMonth:
                    return dateFns.format(this.localDate, 'EEEE, MMMM d');
                case MessageGroup.ThisWeek:
                    return dateFns.format(this.localDate, 'EEEE hh:mm a');
                case MessageGroup.Yesterday:
                    return "Yesterday " + dateFns.format(this.localDate, 'hh:mm a');
                default:
                    return dateFns.format(this.localDate, 'hh:mm a');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "getMessageGroup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (todayDate) {
            if (todayDate === void 0) { todayDate = new Date(); }
            var difference = dateFns.differenceInCalendarDays(todayDate, this.localDate);
            if (difference === 0) {
                return MessageGroup.Today;
            }
            if (difference === 1) {
                return MessageGroup.Yesterday;
            }
            if (difference < 7) {
                return MessageGroup.ThisWeek;
            }
            if (difference < 30) {
                return MessageGroup.ThisMonth;
            }
            if (this.localDate.getMonth() < todayDate.getMonth()
                && todayDate.getFullYear() === this.localDate.getFullYear()) {
                return MessageGroup.ThisYear;
            }
            return MessageGroup.LastNYear;
        }
    });
    __decorate([
        observable
    ], Message.prototype, "messageId", void 0);
    __decorate([
        observable
    ], Message.prototype, "message", void 0);
    __decorate([
        observable
    ], Message.prototype, "userId", void 0);
    __decorate([
        observable
    ], Message.prototype, "userName", void 0);
    __decorate([
        observable
    ], Message.prototype, "displayInitial", void 0);
    __decorate([
        observable
    ], Message.prototype, "dateCreated", void 0);
    __decorate([
        observable
    ], Message.prototype, "blobId", void 0);
    __decorate([
        observable
    ], Message.prototype, "filename", void 0);
    __decorate([
        observable
    ], Message.prototype, "isBeingSent", void 0);
    __decorate([
        observable
    ], Message.prototype, "isDownloading", void 0);
    __decorate([
        computed
    ], Message.prototype, "localDate", null);
    __decorate([
        action
    ], Message.prototype, "getAttachment", null);
    __decorate([
        computed
    ], Message.prototype, "printDate", null);
    __decorate([
        computed
    ], Message.prototype, "printGroupDate", null);
    return Message;
}());
export { Message };
